export const ROUTER = {
  AUTHENTICATION: { LOGIN: "/login" },
  ADMINISTRATION: {},
  CHANGEMAN: { INDEX: "/changeman" },
  CHEFS_ASSISTANT: {
    INDEX: "chefs-assistant",
    CASH_BOOK: "cash-book",
    TECHNICAL_SHEETS: "technical-sheets",
    STOCK: { PRODUCTS: "stock/products", PURCHASE_ORDER: "stock/purchase-order" },
  },
  HEALTH: { PATIENTS: { INDEX: "/health/patients", NEW: "/health/patients/new" } },
  HELP_DESK: { INDEX: "/helpdesk" },
  MAIN: { INDEX: "/", PROFILE: "profile" },
  OVERVIEW: { INDEX: "overview" },
  PROJECT: { INDEX: "project", TIMESHEET: "timesheet" },
  NOT_FOUND: "*",
};
